import { Observable, of } from 'rxjs'
import { Inject, Injectable } from '@angular/core'
import { catchError } from 'rxjs/operators'
import { ActivatedRouteSnapshot, Resolve } from '@angular/router'
import { LOGGER_SERVICE } from '../../logger/logger.config'
import { LoggerService } from '../../logger/logger.interface'
import { CategoryService } from '../../singleton-services/category.service'
import { getRouteQueryParams } from '../../singleton-services/category.service.utility'
import { CategoryView } from '../../libs/category-list/category-list.interface'

@Injectable()
export class AthletesListResolver implements Resolve<readonly CategoryView[] | undefined> {
  constructor(
    @Inject(LOGGER_SERVICE) private readonly log: LoggerService,
    private readonly categoryService: CategoryService
  ) {}

  public resolve(route: ActivatedRouteSnapshot): Observable<readonly CategoryView[] | undefined> {
    const queryParams = getRouteQueryParams(route.queryParamMap)
    return this.categoryService.searchAthletes$(queryParams).pipe(
      catchError(err => {
        this.log.error(err.msg, err.error)
        return of([])
      })
    )
  }
}
